export default {
    A1: {
        t: 's',
        v: '',
    },
    A2: {
        t: 's',
        v: '',
    },
    A3: {
        t: 's',
        v: '',
    },
    A4: {
        t: 's',
        v: '傳票日期',
    },
    B4: {
        t: 's',
        v: '傳票號碼',
    },
    C4: {
        t: 's',
        v: '科目代號',
    },
    D4: {
        t: 's',
        v: '科目名稱',
    },
    E4: {
        t: 's',
        v: '科目屬性',
    },
    F4: {
        t: 's',
        v: '摘要',
    },
    G4: {
        t: 's',
        v: '借方金額',
    },
    H4: {
        t: 's',
        v: '貸方金額',
    },
    '!ref': 'A1:H7',
    '!merges': [
        { s: { c: 0, r: 0 }, e: { c: 7, r: 0 } },
        { s: { c: 0, r: 1 }, e: { c: 7, r: 1 } },
        { s: { c: 0, r: 2 }, e: { c: 7, r: 2 } },
    ],
};
